<template>
  <div class="wang-wrap">
    <Toolbar
      class="wang-toolbar"
      :editor="editorRef"
      :defaultConfig="toolbarConfig"
      mode="default"
    />
    <Editor
      class="wang-editor"
      v-model="valueHtml"
      :defaultConfig="editorConfig"
      mode="default"
      @onCreated="handleCreated"
    />
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import '@wangeditor/editor/dist/css/style.css'
import { onBeforeUnmount, shallowRef, watch, ref } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { uploadImage } from '@/api'

const props = defineProps({
  modelValue: { type: String, default: '' },
})
const emit = defineEmits(['update:modelValue'])

const editorRef = shallowRef()
const valueHtml = ref('')

watch(
  () => props.modelValue,
  (v) => {
    const next = v || ''
    if (next !== valueHtml.value) {
      valueHtml.value = next
    }
  },
  { immediate: true }
)

watch(valueHtml, (v) => {
  emit('update:modelValue', v)
})

/** 富文本入库用相对路径，避免写死本机 127.0.0.1 */
function toStoredMediaPath(rawUrl) {
  const raw = String(rawUrl || '').trim()
  if (!raw) return ''
  if (raw.startsWith('data:')) return raw
  if (/^https?:\/\//i.test(raw)) {
    try {
      return new URL(raw).pathname || raw
    } catch {
      return raw
    }
  }
  return raw.startsWith('/') ? raw : `/${raw}`
}

const toolbarConfig = {}
const editorConfig = {
  placeholder: '点击这里输入活动详情',
  MENU_CONF: {
    uploadImage: {
      // 解决 “Cannot get upload server address / 没有配置上传地址”
      customUpload: async (file, insertFn) => {
        const data = await uploadImage(file)
        const rawUrl = (data && data.url) || ''
        if (!rawUrl) throw new Error('上传成功但未返回图片地址')
        const path = toStoredMediaPath(rawUrl)
        insertFn(path, '', path)
      },
    },
  },
}

function handleCreated(editor) {
  editorRef.value = editor
}

onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})
</script>

<style scoped>
.wang-wrap {
  border: 1px solid #d0d7e2;
  border-radius: 10px;
  overflow: visible;
  background: #fff;
  position: relative;
}
.wang-toolbar {
  border-bottom: 1px solid #e5e7eb;
  position: relative;
  z-index: 6;
}
.wang-editor {
  height: 420px;
  overflow-y: auto;
  position: relative;
  z-index: 1;
}
:deep(.w-e-text-placeholder) {
  color: #98a2b3;
}
:deep(.w-e-toolbar),
:deep(.w-e-text-container) {
  z-index: 1;
}
:deep(.w-e-drop-panel),
:deep(.w-e-panel-container),
:deep(.w-e-modal),
:deep(.w-e-hover-bar) {
  z-index: 2000;
}
</style>
